import {createSelector} from 'reselect'
import getDomainSettings from 'jsonFetches/getDomainSettings'

export const getTextTags = () => {
  let model = {
    appName: '',
    shortCompanyName: '',
    companyName: ''
  }

  try {
    const settings = getDomainSettings()[window.location.hostname];

    model = {
      appName: settings.appName,
      shortCompanyName: settings.mainSortName,
      companyName: settings.mainWebsiteUrlLabel
    }
  } catch (error) {

  }

  return model
}

export const getAppName = () => {
  return (getDomainSettings()[window.location.hostname].appName)
}

export const getCompanyName = () => {
  return (getDomainSettings()[window.location.hostname].companyName)

}
  
export const getTopLevelDomainName = () =>
  (getDomainSettings()[window.location.hostname].mainWebsiteUrl)

export const getTld = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].tld)
)

export const getTldLocale = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].langCode)
)

export const getTldEmail = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].mainEmail)
)
